import apiConfig from "../config/api";

/**
 * Request para hacer HTTP POST al servicio MS-Utilities api/logging/agendamiento.experto
 * para hacer el logging del click del boton en el menu empresas
 * @param {*} empresaData Rut empresa y nombre empresa
 */
export const loggingAgndamientoExpertoClicks = (companyId, companyName) => {
  fetch(`${apiConfig.apiUri}api/logging/agendamientoexperto`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
    },
    body: JSON.stringify({
      RutEmpresa: companyId,
      NombreEmpresa: companyName,
    }),
  });
};
